(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9335],{

/***/ 59884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var antd_lib_modal_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63787);
/* harmony import */ var antd_lib_modal_style__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(antd_lib_modal_style__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var antd_lib_modal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18397);
/* harmony import */ var antd_lib_button_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41100);
/* harmony import */ var antd_lib_button_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(antd_lib_button_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var antd_lib_button__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(92743);
/* harmony import */ var _workspace_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(72995);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var utils_index__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25427);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);






function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_workspace_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var TryModal = function TryModal(props, ref) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({
    error: false,
    visible: false
  }),
      modalInfo = _useState[0],
      setModalInfo = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      isMobile = _useState2[0],
      setIsMobile = _useState2[1];

  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function () {
    setIsMobile((0,utils_index__WEBPACK_IMPORTED_MODULE_6__/* .platform */ .Jv)().mobile);
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_3__.useImperativeHandle)(ref, function () {
    return {
      open: function open(error, visible) {
        return setModalInfo({
          error: error,
          visible: visible
        });
      }
    };
  });

  var onClose = function onClose() {
    return setModalInfo(_objectSpread(_objectSpread({}, modalInfo), {}, {
      visible: false
    }));
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(antd_lib_modal__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
    onCancel: onClose,
    closable: isMobile ? false : true,
    visible: modalInfo.visible,
    footer: null,
    className: classnames__WEBPACK_IMPORTED_MODULE_4___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().modal), modalInfo.error && (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().errModal)),
    children: [modalInfo.error ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().errTitle),
        children: "\u63D0\u4EA4\u5931\u8D25"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().errText),
        children: "\u51FA\u4E86\u70B9\u95EE\u9898\uFF0C\u8BF7\u7A0D\u540E\u518D\u8BD5\u3002"
      })]
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
        src: '/v2/images/success.svg',
        alt: "success",
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().successIcon)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().successText),
        children: ["\u60A8\u7684\u4FE1\u606F\u5DF2\u7ECF\u63D0\u4EA4\u6210\u529F ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("br", {}), " \u6211\u4EEC\u4F1A\u5C3D\u5FEB\u4E0E\u60A8\u53D6\u5F97\u8054\u7CFB\uFF01"]
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_4___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().btn), modalInfo.error && (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().error)),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(antd_lib_button__WEBPACK_IMPORTED_MODULE_9__["default"], {
        type: "primary",
        onClick: onClose,
        children: "\u77E5\u9053\u4E86"
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.forwardRef(TryModal));

/***/ }),

/***/ 49048:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_lib_button_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41100);
/* harmony import */ var antd_lib_button_style__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(antd_lib_button_style__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var antd_lib_button__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(92743);
/* harmony import */ var antd_lib_row_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63621);
/* harmony import */ var antd_lib_row_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(antd_lib_row_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var antd_lib_row__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(34366);
/* harmony import */ var antd_lib_col_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56033);
/* harmony import */ var antd_lib_col_style__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(antd_lib_col_style__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var antd_lib_col__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(29242);
/* harmony import */ var antd_lib_input_style__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40861);
/* harmony import */ var antd_lib_input_style__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(antd_lib_input_style__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var antd_lib_input__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(38706);
/* harmony import */ var _workspace_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(50029);
/* harmony import */ var _workspace_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(16835);
/* harmony import */ var antd_lib_form_style__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42213);
/* harmony import */ var antd_lib_form_style__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(antd_lib_form_style__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var antd_lib_form__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(76290);
/* harmony import */ var _workspace_repo_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87794);
/* harmony import */ var _workspace_repo_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_workspace_repo_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var components_layout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16569);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67294);
/* harmony import */ var styles_contact_index_module_scss__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(89346);
/* harmony import */ var styles_contact_index_module_scss__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(styles_contact_index_module_scss__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var action_index__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(37121);
/* harmony import */ var components_tryModal_index__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(59884);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85893);





















var FormItem = antd_lib_form__WEBPACK_IMPORTED_MODULE_12__/* ["default"].Item */ .Z.Item;
var pageTitle = '联系销售';

var Contact = function Contact() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(false),
      submitStatus = _useState[0],
      setSubmitStatus = _useState[1];

  var _Form$useForm = antd_lib_form__WEBPACK_IMPORTED_MODULE_12__/* ["default"].useForm */ .Z.useForm(),
      _Form$useForm2 = (0,_workspace_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var modalRef = (0,react__WEBPACK_IMPORTED_MODULE_8__.useRef)(null);

  var onFinish = /*#__PURE__*/function () {
    var _ref = (0,_workspace_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)( /*#__PURE__*/_workspace_repo_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_5___default().mark(function _callee(values) {
      var result, _modalRef$current, _modalRef$current$ope, _modalRef$current2, _modalRef$current2$op;

      return _workspace_repo_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_5___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setSubmitStatus(true);

              if (values) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:
              values.applicationType = '0';
              _context.next = 6;
              return action_index__WEBPACK_IMPORTED_MODULE_9__/* .action.submit */ .a.submit(values, 'contact');

            case 6:
              result = _context.sent;

              if (!result) {
                (_modalRef$current = modalRef.current) === null || _modalRef$current === void 0 ? void 0 : (_modalRef$current$ope = _modalRef$current.open) === null || _modalRef$current$ope === void 0 ? void 0 : _modalRef$current$ope.call(_modalRef$current, false, true);
              } else {
                (_modalRef$current2 = modalRef.current) === null || _modalRef$current2 === void 0 ? void 0 : (_modalRef$current2$op = _modalRef$current2.open) === null || _modalRef$current2$op === void 0 ? void 0 : _modalRef$current2$op.call(_modalRef$current2, true, true);
              }

              form.resetFields();
              setSubmitStatus(false);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onFinish(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(components_layout__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_7___default()), {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("title", {
        children: pageTitle
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
      className: (styles_contact_index_module_scss__WEBPACK_IMPORTED_MODULE_15___default().banner),
      children: pageTitle
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
      className: (styles_contact_index_module_scss__WEBPACK_IMPORTED_MODULE_15___default().form),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(antd_lib_form__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
        form: form,
        className: (styles_contact_index_module_scss__WEBPACK_IMPORTED_MODULE_15___default().formInfo),
        onFinish: onFinish,
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
          className: (styles_contact_index_module_scss__WEBPACK_IMPORTED_MODULE_15___default().title),
          children: pageTitle
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(antd_lib_row__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
          gutter: 30,
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(antd_lib_col__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
            md: 12,
            xs: 24,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(FormItem, {
              name: 'contactName',
              rules: [{
                required: true,
                message: '请填写您的姓名'
              }],
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(antd_lib_input__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                placeholder: "\u60A8\u7684\u59D3\u540D"
              })
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(antd_lib_col__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
            md: 12,
            xs: 24,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(FormItem, {
              name: 'contactPhone',
              rules: [{
                required: true,
                message: '请填写您的联系电话'
              }, {
                pattern: /^1[3|4|5|6|7|8|9]\d{9}$/,
                message: '填写的电话号码格式不正确'
              }],
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(antd_lib_input__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                placeholder: "\u8054\u7CFB\u7535\u8BDD"
              })
            })
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(antd_lib_row__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
          gutter: 24,
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(antd_lib_col__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
            md: 12,
            xs: 24,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(FormItem, {
              name: 'contactEmail',
              rules: [{
                required: true,
                message: '请填写您的邮箱'
              }, {
                type: 'email',
                message: '您填写的邮箱格式不正确'
              }],
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(antd_lib_input__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                placeholder: "\u60A8\u7684\u90AE\u7BB1"
              })
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(antd_lib_col__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
            md: 12,
            xs: 24,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(FormItem, {
              name: 'contactEnterpriseName',
              rules: [{
                required: true,
                message: '请填写您的公司名称'
              }],
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(antd_lib_input__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                placeholder: "\u516C\u53F8\u540D\u79F0"
              })
            })
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(FormItem, {
          name: 'customerDemand',
          className: (styles_contact_index_module_scss__WEBPACK_IMPORTED_MODULE_15___default().textArea),
          rules: [{
            required: true,
            message: '请填写您的需求'
          }],
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(antd_lib_input__WEBPACK_IMPORTED_MODULE_18__/* ["default"].TextArea */ .Z.TextArea, {
            placeholder: "\u60A8\u7684\u9700\u6C42"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(FormItem, {
          className: (styles_contact_index_module_scss__WEBPACK_IMPORTED_MODULE_15___default().submit),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(antd_lib_button__WEBPACK_IMPORTED_MODULE_19__["default"], {
            type: "primary",
            htmlType: "submit",
            loading: submitStatus,
            children: submitStatus ? '提交中...' : '提交'
          })
        })]
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("footer", {
      className: (styles_contact_index_module_scss__WEBPACK_IMPORTED_MODULE_15___default().footer),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
        className: (styles_contact_index_module_scss__WEBPACK_IMPORTED_MODULE_15___default().title),
        children: "\u60A8\u4E5F\u53EF\u4EE5\u901A\u8FC7\u4EE5\u4E0B\u65B9\u5F0F\u8054\u7CFB\u9500\u552E"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
        className: (styles_contact_index_module_scss__WEBPACK_IMPORTED_MODULE_15___default().phone),
        children: "400-900-3567"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
        className: (styles_contact_index_module_scss__WEBPACK_IMPORTED_MODULE_15___default().email),
        children: "sales@xylink.com"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(components_tryModal_index__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
      ref: modalRef
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (Contact);

/***/ }),

/***/ 93328:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact",
      function () {
        return __webpack_require__(49048);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 72995:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"border__px":"tryModal_border__px__o8KMt","border__px-before":"tryModal_border__px-before__msrcp","border__px-before1":"tryModal_border__px-before1__78VJP","border-children1":"tryModal_border-children1__zDNsw","border-children2":"tryModal_border-children2__iZRlT","for-mobile":"tryModal_for-mobile__rUFFH","for-pc":"tryModal_for-pc__HJ4i0","modal":"tryModal_modal__Clzhe","successText":"tryModal_successText__Gllz1","errTitle":"tryModal_errTitle__oNhim","errText":"tryModal_errText__3qXjX","successIcon":"tryModal_successIcon__YuSpW","btn":"tryModal_btn__Mt_um","error":"tryModal_error__PAYWB","errModal":"tryModal_errModal__OsgeI"};

/***/ }),

/***/ 89346:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"border__px":"contact_border__px__FkAcT","border__px-before":"contact_border__px-before__Lu96T","border__px-before1":"contact_border__px-before1___ULFv","border-children1":"contact_border-children1__uTHtT","border-children2":"contact_border-children2__QyC0y","for-mobile":"contact_for-mobile__bIBr_","for-pc":"contact_for-pc__EFg43","footer":"contact_footer__ICJC3","form":"contact_form__kkCPW","banner":"contact_banner__Zl_fY","title":"contact_title__kAhxX","formInfo":"contact_formInfo__e8FD7","submit":"contact_submit__8WrVq","textArea":"contact_textArea__9Ot7V","phone":"contact_phone__Cr3NM","email":"contact_email__VNP_p"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1747,4662,2178,3528,9774,2888,179], function() { return __webpack_exec__(93328); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);